/**
 * Loads Wildhawk/Freewill pack products (single / 3 / 5 / 7) via Shopify Product Ajax API
 * (GET {localeRoot}products/{handle}.js). Handles are supplied by Liquid from product IDs.
 */
// @ts-nocheck
(function () {
  const targets = window.__WILDHAWK_PACK_TARGETS__;
  if (!Array.isArray(targets) || targets.length === 0) return;

  function getPromoForKey(productKey) {
    var promoMap = window.__WILDHAWK_PACK_PROMO__;
    if (!promoMap || !productKey) return null;
    return promoMap[productKey] || null;
  }

  const root =
    typeof window.Shopify !== 'undefined' &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  function productUrl(handle) {
    return `${root}products/${encodeURIComponent(handle)}.js`;
  }

  function normalizeProduct(raw) {
    var options = (raw.options || [])
      .slice()
      .sort(function (a, b) {
        return (a.position || 0) - (b.position || 0);
      })
      .map(function (o) {
        return {
          name: o.name,
          position: o.position,
          values: o.values ? o.values.slice() : [],
        };
      });

    var optionCount = options.length || 0;

    // Shopify variants include option1/option2/option3. We'll build a lookup by option values.
    var variants = (raw.variants || []).map(function (v) {
      var ov1 = v.option1 != null ? String(v.option1) : '';
      var ov2 = v.option2 != null ? String(v.option2) : '';
      var ov3 = v.option3 != null ? String(v.option3) : '';
      var optionValues = [ov1, ov2, ov3].slice(0, Math.max(1, optionCount));
      var signature = optionValues
        .map(function (x) {
          return x.trim();
        })
        .join('|');

      var optionByName = {};
      options.forEach(function (opt, idx) {
        optionByName[opt.name] = optionValues[idx] != null ? optionValues[idx] : '';
      });

      var sku = v.sku != null ? String(v.sku) : '';
      var inventoryQty = v.inventory_quantity != null ? Number(v.inventory_quantity) : null;
      if (
        (inventoryQty == null || !isFinite(inventoryQty)) &&
        window.__WILDHAWK_VARIANT_INVENTORY__ &&
        v.id != null &&
        window.__WILDHAWK_VARIANT_INVENTORY__[String(v.id)] != null
      ) {
        inventoryQty = Number(window.__WILDHAWK_VARIANT_INVENTORY__[String(v.id)]);
      }
      var forcedSoldOut = v.available === false;

      return {
        id: v.id,
        name: v.public_title != null ? v.public_title : v.title,
        sku: sku,
        inventory_quantity: inventoryQty,
        inventory_management: v.inventory_management || v.inventoryManagement || null,
        // Keep pricing in the normalized variant object so the catalog can be reused later.
        price: v.price != null ? v.price : '',
        compare_at_price: v.compare_at_price != null ? v.compare_at_price : '',
        available: forcedSoldOut ? false : v.available != null ? v.available : false,
        optionValues: optionValues,
        signature: signature,
        optionByName: optionByName,
      };
    });

    var variantBySignature = {};
    variants.forEach(function (variant) {
      if (!variant.signature) return;
      variantBySignature[variant.signature] = variant.id;
    });

    var variantById = {};
    variants.forEach(function (variant) {
      if (!variant || variant.id == null) return;
      variantById[String(variant.id)] = variant;
    });

    var media = (raw.media || []).map(function (m) {
      var variantIds = m.variant_ids || m.variantIds || [];
      if (!Array.isArray(variantIds)) variantIds = [];

      var previewSrc = m.preview_image && m.preview_image.src ? m.preview_image.src : (m.thumb && m.thumb.src ? m.thumb.src : '');
      var mainSrc = m.src || previewSrc;

      return {
        id: m.id,
        media_type: m.media_type,
        type: m.media_type,
        alt: m.alt || '',
        src: mainSrc,
        thumb: previewSrc || mainSrc,
        variantIds: variantIds,
        host: m.host,
        sources: m.sources || [],
      };
    });

    // Fallback: some product endpoints may not include `media` (or may omit alts).
    // In that case, at least carry the product's image URLs so pack switching still swaps galleries.
    if ((!media || media.length === 0) && Array.isArray(raw.images) && raw.images.length > 0) {
      media = raw.images
        .map(function (src, idx) {
          return {
            id: 'img-' + String(raw.id || '') + '-' + String(idx),
            media_type: 'image',
            type: 'image',
            alt: '',
            src: src,
            thumb: src,
            variantIds: [],
            host: null,
            sources: [],
          };
        })
        .filter(function (m) {
          return !!m && !!m.src;
        });
    }

    return {
      productId: raw.id,
      handle: raw.handle,
      title: raw.title != null ? String(raw.title) : '',
      options: options,
      optionCount: optionCount,
      media: media,
      variants: variants,
      variantBySignature: variantBySignature,
      variantById: variantById,
    };
  }

  async function loadPackCatalog() {
    const catalog = {};

    await Promise.all(
      targets.map(async function (t) {
        if (!t.handle || !t.id) {
          console.warn('[Wildhawk pack] Missing handle for', t.key, 'expected id', t.id);
          return;
        }

        const res = await fetch(productUrl(t.handle), {
          headers: { Accept: 'application/json' },
        });

        if (!res.ok) {
          console.error('[Wildhawk pack] Failed to load', t.key, productUrl(t.handle), res.status);
          if (t.title) {
            catalog[t.key] = {
              productId: t.id,
              handle: t.handle,
              title: String(t.title),
              options: [],
              optionCount: 0,
              media: [],
              variants: [],
              variantBySignature: {},
              variantById: {},
            };
          }
          return;
        }

        const raw = await res.json();

        if (Number(raw.id) !== Number(t.id)) {
          console.warn('[Wildhawk pack] Product id mismatch for', t.key, 'expected', t.id, 'got', raw.id);
        }

        catalog[t.key] = normalizeProduct(raw);
      })
    );

    window.wildhawkPackCatalog = catalog;

    initPackVariantSync(catalog);
    if (window.WildhawkStockout && typeof window.WildhawkStockout.applyToPdpPicker === 'function') {
      window.WildhawkStockout.applyToPdpPicker(document);
    }

    window.setTimeout(function () {
      var r = document.querySelector('[data-wildhawk-pack-pdp]');
      if (r && r.classList && !r.classList.contains('wildhawk-pack-prices-ready')) {
        r.classList.add('wildhawk-pack-prices-ready');
      }
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadPackCatalog);
  } else {
    loadPackCatalog();
  }

  function getSelectedOptionValueMaps(formEl) {
    var optionMapByPosition = {};
    var optionMapByName = {};

    // Buttons/radios
    var checkedRadios = formEl.querySelectorAll('input[type="radio"]:checked');
    checkedRadios.forEach(function (input) {
      var inputId = input.dataset && input.dataset.inputId ? input.dataset.inputId : '';
      var positionStr = String(inputId).split('-')[0];
      var position = parseInt(positionStr, 10);
      if (!position || isNaN(position)) return;
      optionMapByPosition[position] = String(input.value);

      // Best-effort option-name extraction from the fieldset class: `type-{{ product_option.name }}`
      var fieldset = input.closest ? input.closest('fieldset') : null;
      var typeClass = fieldset
        ? Array.from(fieldset.classList).find(function (c) {
            return c && c.indexOf('type-') === 0;
          })
        : null;
      if (typeClass) {
        var optionName = typeClass.slice('type-'.length);
        if (optionName) optionMapByName[optionName] = String(input.value);
      }
    });

    // Dropdowns
    var selects = formEl.querySelectorAll('select[name^="options["]');
    selects.forEach(function (selectEl) {
      var selectedOption =
        (selectEl.selectedOptions && selectEl.selectedOptions[0]) || selectEl.querySelector('option:checked');
      if (!selectedOption) return;
      var inputId = selectedOption.dataset && selectedOption.dataset.inputId ? selectedOption.dataset.inputId : '';
      var positionStr = String(inputId).split('-')[0];
      var position = parseInt(positionStr, 10);
      if (!position || isNaN(position)) return;
      optionMapByPosition[position] = String(selectedOption.value);

      var nameAttr = selectEl.getAttribute('name') || '';
      var m = nameAttr.match(/^options\[(.*)\]$/);
      if (m && m[1]) optionMapByName[m[1]] = String(selectedOption.value);
    });

    return { byPosition: optionMapByPosition, byName: optionMapByName };
  }

  function buildSignature(optionMap, optionCount) {
    var values = [];
    for (var i = 1; i <= optionCount; i++) {
      values.push(optionMap[i] ? String(optionMap[i]).trim() : '');
    }
    return values.join('|');
  }

  function findVariantIdForPack(packKey, selectedOptions) {
    var product = window.wildhawkPackCatalog && window.wildhawkPackCatalog[packKey];
    if (!product) return null;

    if (!selectedOptions) return null;
    var optionMap = selectedOptions.byPosition || {};
    var optionMapByName = selectedOptions.byName || {};

    var hasPos = Object.keys(optionMap).some(function (k) {
      return String(optionMap[k] || '').trim() !== '';
    });
    var hasName = Object.keys(optionMapByName).some(function (k) {
      return String(optionMapByName[k] || '').trim() !== '';
    });
    if (!hasPos && !hasName && product.variants && product.variants.length === 1) {
      return product.variants[0].id;
    }

    // 1) Fast path: signature by option position (option1/option2/option3)
    var optionCount = product.optionCount || 0;
    if (optionMap && Object.keys(optionMap).length > 0) {
      var signature = buildSignature(optionMap, optionCount);

      if (signature && product.variantBySignature && product.variantBySignature[signature]) {
        return product.variantBySignature[signature];
      }
    }

    // Fallback: partial match. Compare only positions that have a selected value.
    if (optionMap && Object.keys(optionMap).length > 0) {
      var selectedPositions = Object.keys(optionMap)
      .map(function (k) {
        return parseInt(k, 10);
      })
      .filter(function (n) {
        return !isNaN(n) && n > 0;
      });

      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        var matches = true;
        for (var j = 0; j < selectedPositions.length; j++) {
          var pos = selectedPositions[j];
          var idx = pos - 1;
          var selectedValue = String(optionMap[pos] || '').trim();
          if (!selectedValue) continue;
          var variantValue = variant.optionValues[idx] != null ? String(variant.optionValues[idx]).trim() : '';
          if (variantValue !== selectedValue) {
            matches = false;
            break;
          }
        }
        if (matches) return variant.id;
      }
    }

    // 2) Robust fallback: match by option name (fixes option-order mismatches across products)
    if (optionMapByName && Object.keys(optionMapByName).length > 0) {
      for (var ii = 0; ii < product.variants.length; ii++) {
        var v = product.variants[ii];
        var ok = true;

        for (var oi = 0; oi < product.options.length; oi++) {
          var opt = product.options[oi];
          var selectedVal = optionMapByName[opt.name];
          if (selectedVal == null || selectedVal === '') continue;

          var variantVal = v.optionByName && v.optionByName[opt.name] != null ? String(v.optionByName[opt.name]).trim() : '';
          if (variantVal !== String(selectedVal).trim()) {
            ok = false;
            break;
          }
        }

        if (ok) return v.id;
      }
    }

    return null;
  }

  function setHiddenVariantId(variantId) {
    if (!variantId) return;
    var inputs = document.querySelectorAll('input[type="hidden"][name="id"][ref="variantId"]');
    inputs.forEach(function (el) {
      el.value = String(variantId);
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initPackVariantSync(catalog) {
    if (!catalog || typeof catalog !== 'object') return;

    var switcher = document.querySelector('.wildhawk-product-pack-switcher');
    if (!switcher) {
      console.warn('[Wildhawk pack] Missing .wildhawk-product-pack-switcher');
      return;
    }

    var activePackKey = null;
    var activeStyleKey = null;

    function normalizeStyleKey(raw) {
      var v = String(raw || '').toLowerCase().trim();
      if (!v) return null;
      // Accept values like "Boxer Brief", "Boxer Briefs", "Brief", "Briefs".
      if (v.indexOf('boxer') >= 0) return 'boxerBrief';
      if (v.indexOf('brief') >= 0) return 'brief';
      return null;
    }

    function styleKeyToDisplayValue(styleKey) {
      if (styleKey === 'boxerBrief') return 'Boxer Brief';
      if (styleKey === 'brief') return 'Brief';
      return '';
    }

    /** Freewill uses the same Style UI as Wildhawk but `__WILDHAWK_PACK_STYLE_SPLIT__` is off (three-tier catalog only). */
    function hasWildhawkPackStyleUi() {
      return !!document.querySelector('input[data-wildhawk-pack-style]');
    }

    function packKeyToTitleSuffix(packKey) {
      if (packKey === 'single') return 'single';
      if (packKey === 'threePack') return '3-pack';
      if (packKey === 'fivePack') return '5-pack';
      if (packKey === 'sevenPack') return '7-pack';
      return '';
    }

    function titleWithPackSuffix(title, packKey) {
      var suffix = packKeyToTitleSuffix(packKey);
      if (!title || !suffix) return '';
      var next = String(title).replace(/\s+(single|3-pack|5-pack|7-pack)\s*$/i, ' ' + suffix);
      if (next !== String(title)) return next;
      return String(title).replace(/\s+$/, '') + ' ' + suffix;
    }

    function deriveTitleForActivePack() {
      var tryKeys = [];
      if (activeStyleKey) {
        tryKeys.push(
          'sevenPack__' + activeStyleKey,
          'fivePack__' + activeStyleKey,
          'threePack__' + activeStyleKey,
          'single__' + activeStyleKey
        );
      }
      tryKeys.push('sevenPack', 'fivePack', 'threePack', 'single');
      var i;
      var entry;
      for (i = 0; i < tryKeys.length; i++) {
        entry = catalog[tryKeys[i]];
        if (entry && entry.title) return titleWithPackSuffix(entry.title, activePackKey);
      }
      return '';
    }

    /** PDP heading: visible `.stitch-product-title` uses the active pack product title from the catalog. */
    function syncStitchProductTitle() {
      var p = document.querySelector('.stitch-product-title');
      if (!p) return;

      var catalogKey = getActiveCatalogKey();
      var entry = catalogKey && catalog[catalogKey];
      var title = entry && entry.title ? entry.title : deriveTitleForActivePack();
      if (title) {
        p.textContent = title;
        return;
      }

      if (!window.__WILDHAWK_PACK_STYLE_SPLIT__ && !hasWildhawkPackStyleUi()) return;
      var wrap = document.querySelector('.container-for__stitch-product-title');
      if (!wrap) return;
      var h1 = wrap.querySelector('h1');
      if (!h1) return;

      if (!wrap.dataset.stitchBaseTitle) {
        var initial = (h1.textContent || '').split(' ')[0].trim();
        if (!initial) return;
        wrap.dataset.stitchBaseTitle = initial;
      }

      var base = wrap.dataset.stitchBaseTitle;
      var label = styleKeyToDisplayValue(activeStyleKey);
      if (label === 'Boxer Brief') {
        label = 'boxer briefs';
      } else if (label === 'Brief') {
        label = 'briefs';
      }
      if (!label) return;
      p.textContent = base + ' ' + label;
    }

    function getActiveStyleKeyFromUi() {
      var checked = document.querySelector('input[data-wildhawk-pack-style]:checked');
      return checked ? normalizeStyleKey(checked.value) : null;
    }

    function syncStyleLegendAndSelectedClasses() {
      var fs = document.querySelector('[data-wildhawk-pack-style-fieldset]');
      if (!fs) return;
      var legendValue = fs.querySelector('.variant-option__swatch-value');
      if (legendValue) legendValue.textContent = styleKeyToDisplayValue(activeStyleKey) || '';

      fs.querySelectorAll('label.variant-option__button-label').forEach(function (label) {
        label.classList.remove('is-selected');
      });
      var checked = fs.querySelector('input[data-wildhawk-pack-style]:checked');
      if (checked) {
        var label = checked.closest && checked.closest('label.variant-option__button-label');
        if (label) label.classList.add('is-selected');
      }
    }

    function resolveCatalogKey(packKey, styleKey) {
      if (!packKey) return null;
      if (styleKey && catalog[packKey + '__' + styleKey]) return packKey + '__' + styleKey;
      return packKey;
    }

    function getActiveCatalogKey() {
      return resolveCatalogKey(activePackKey, activeStyleKey);
    }

    function withPackStyleSelection(selectedOptions) {
      var base = selectedOptions || { byPosition: {}, byName: {} };
      if (!base.byPosition) base.byPosition = {};
      if (!base.byName) base.byName = {};
      if (window.__WILDHAWK_PACK_STYLE_SPLIT__) {
        var styleVal = styleKeyToDisplayValue(activeStyleKey);
        if (styleVal) base.byName.Style = styleVal;
      }
      return base;
    }
    function syncPackButtonActiveState() {
      if (!activePackKey) return;
      switcher.querySelectorAll('.pack-btn[data-pack-key]').forEach(function (b) {
        if (b.dataset && b.dataset.packKey === activePackKey) b.classList.add('active');
        else b.classList.remove('active');
      });
    }

    function matchCatalogFromUrlHandle() {
      var path = window.location.pathname || '';
      var m = path.match(/\/products\/([^\/\?]+)/);
      if (!m || !m[1]) return null;
      var currentHandle = m[1];
      var matched = null;
      Object.keys(catalog).some(function (k) {
        if (catalog[k].handle !== currentHandle) return false;
        if (String(k).indexOf('__') >= 0) {
          var parts = String(k).split('__');
          matched = { packKey: parts[0], styleKey: parts[1] || null };
        } else {
          matched = { packKey: k, styleKey: null };
        }
        return true;
      });
      return matched;
    }

    var defaultPackMode = (switcher.dataset && switcher.dataset.wildhawkDefaultPack) || 'from_url';
    var urlCatalogMatch = matchCatalogFromUrlHandle();

    var activeBtn = switcher.querySelector('.pack-btn.active[data-pack-key]');
    if (activeBtn && activeBtn.dataset && activeBtn.dataset.packKey) {
      activePackKey = activeBtn.dataset.packKey;
    }

    // Keep Liquid's highlighted pack unless the setting is from_url, or the opened
    // product is the exception page (5-pack for three_pack default, 7-pack for five_pack).
    // Style (boxer/brief) always follows the URL product.
    if (urlCatalogMatch) {
      if (urlCatalogMatch.styleKey) {
        activeStyleKey = urlCatalogMatch.styleKey;
      }
      if (defaultPackMode === 'from_url') {
        activePackKey = urlCatalogMatch.packKey;
      } else if (defaultPackMode === 'five_pack' && urlCatalogMatch.packKey === 'sevenPack') {
        activePackKey = 'sevenPack';
      } else if (defaultPackMode === 'three_pack' && urlCatalogMatch.packKey === 'fivePack') {
        activePackKey = 'fivePack';
      } else if (defaultPackMode === 'three_pack' && urlCatalogMatch.packKey === 'sevenPack') {
        activePackKey = 'sevenPack';
      }
    }

    if (!activePackKey) {
      if (urlCatalogMatch) {
        activePackKey = urlCatalogMatch.packKey;
        if (!activeStyleKey && urlCatalogMatch.styleKey) {
          activeStyleKey = urlCatalogMatch.styleKey;
        }
      }
    }

    if (!activePackKey) {
      var keys = Object.keys(catalog);
      activePackKey = catalog.single
        ? 'single'
        : catalog.onePack
          ? 'onePack'
          : keys.length
            ? keys[0]
            : null;
    }

    if (!activeStyleKey) {
      activeStyleKey = getActiveStyleKeyFromUi();
    }
    if (!activeStyleKey && (window.__WILDHAWK_PACK_STYLE_SPLIT__ || hasWildhawkPackStyleUi())) {
      activeStyleKey = 'boxerBrief';
    }
    if (window.__WILDHAWK_PACK_STYLE_SPLIT__ || hasWildhawkPackStyleUi()) {
      // Ensure the right radio is checked (in case template default doesn't match URL).
      var want = styleKeyToDisplayValue(activeStyleKey);
      var wantInput = want ? document.querySelector('input[data-wildhawk-pack-style][value="' + want.replace(/"/g, '\\"') + '"]') : null;
      if (wantInput) wantInput.checked = true;
      syncStyleLegendAndSelectedClasses();
    }

    syncPackButtonActiveState();

    // Before this runs, Liquid may show the URL product price (e.g. higher single / MSRP-only). Lock headline to active pack tier from bootstrap targets immediately.
    updateProductPriceBlock(getActiveCatalogKey(), null);

    function getBuyButtonsBlock() {
      // Prefer the buy-buttons block that actually has the main PDP form + price span.
      // `document.querySelector('.buy-buttons-block')` can hit another block first (no .hold-sp-price).
      var root = (switcher && switcher.closest('.product-information-new')) || document;
      var blocks = root.querySelectorAll('.buy-buttons-block');
      var i;
      var b;
      for (i = 0; i < blocks.length; i++) {
        b = blocks[i];
        if (
          b.querySelector('input[type="hidden"][name="id"][ref="variantId"]') &&
          b.querySelector('.hold-sp-price')
        ) {
          return b;
        }
      }
      for (i = 0; i < blocks.length; i++) {
        b = blocks[i];
        if (b.querySelector('input[type="hidden"][name="id"][ref="variantId"]')) return b;
      }
      if (blocks.length) return blocks[0];

      var hiddenInputs = document.querySelectorAll('input[type="hidden"][name="id"][ref="variantId"]');
      for (i = 0; i < hiddenInputs.length; i++) {
        var input = hiddenInputs[i];
        var bb = input.closest && input.closest('.buy-buttons-block');
        if (bb) return bb;
      }

      return null;
    }

    function wildhawkPackRequiresSize(formEl) {
      if (!formEl) return false;
      return !!(
        formEl.querySelector('fieldset.type-Size') ||
        formEl.querySelector('select[name="options[Size]"]')
      );
    }

    function wildhawkSizeSelected(formEl) {
      if (!formEl) return true;
      var sizeFs = formEl.querySelector('fieldset.type-Size');
      var sizeSel = formEl.querySelector('select[name="options[Size]"]');
      if (!sizeFs && !sizeSel) return true;
      if (sizeFs) {
        if (sizeFs.classList.contains('size-selected')) return true;
        if (sizeFs.querySelector('input[type="radio"]:checked')) return true;
      }
      if (sizeSel) {
        var v = sizeSel.value;
        if (v != null && String(v).trim() !== '') return true;
      }
      return false;
    }

    function clearHiddenVariantIds() {
      document.querySelectorAll('input[type="hidden"][name="id"][ref="variantId"]').forEach(function (el) {
        el.value = '';
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function getPackPdpRoot() {
      return (
        document.querySelector('[data-wildhawk-pack-pdp]') ||
        document.querySelector('.product-information-new')
      );
    }

    function showWildhawkPackAtcUi() {
      var root = getPackPdpRoot();
      if (!root) return;
      root.querySelector('.buy-buttons-block')?.classList.add('buy-buttons-block--atc-visible');
      var hint = root.querySelector('.btn-select-size');
      if (hint instanceof HTMLElement) hint.style.display = 'none';
      var buttons = root.querySelector('product-form-component .product-form-buttons');
      if (buttons instanceof HTMLElement) buttons.style.display = 'flex';
    }

    function hideWildhawkPackAtcUi() {
      var root = getPackPdpRoot();
      if (!root) return;
      root.querySelector('.buy-buttons-block')?.classList.remove('buy-buttons-block--atc-visible');
      var hint = root.querySelector('.btn-select-size');
      if (hint instanceof HTMLElement) hint.style.removeProperty('display');
      var buttons = root.querySelector('product-form-component .product-form-buttons');
      if (buttons instanceof HTMLElement) buttons.style.display = 'none';
      if (window.WhLowStock) window.WhLowStock.hide(root);
    }

    function setWildhawkAddToCartDisabled(disabled) {
      var buy = getBuyButtonsBlock();
      if (!buy) return;
      var addBtn = buy.querySelector('button[name="add"]');
      if (addBtn) {
        if (disabled) {
          addBtn.setAttribute('disabled', 'true');
          addBtn.disabled = true;
        } else {
          addBtn.removeAttribute('disabled');
          addBtn.disabled = false;
        }
      }
      var accel = buy.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
      if (accel) {
        if (disabled) accel.setAttribute('hidden', 'true');
        else accel.removeAttribute('hidden');
      }
    }

    /** Called from variant-picker after a non–Size option fetch when we skip variant:update. */
    function ensureAtcDisabledIfNoSizeSelected() {
      var f = getFormEl();
      if (!f || !wildhawkPackRequiresSize(f) || wildhawkSizeSelected(f)) return;
      hideWildhawkPackAtcUi();
      setWildhawkAddToCartDisabled(true);
    }

    window.wildhawkPackEnsureAtcDisabledIfNoSize = ensureAtcDisabledIfNoSizeSelected;
    window.wildhawkPackShowAtcUi = showWildhawkPackAtcUi;

    function syncGalleryIfNeeded(selectedOptions) {
      var selectedColor = getSelectedOptionValue(selectedOptions, 'color');
      var selectedStyle = getSelectedOptionValue(selectedOptions, 'style');
      var initialSync = !hasInitializedGallery;
      var packChanged = lastGalleryPackKey !== getActiveCatalogKey();
      var colorChanged = selectedColor && lastGalleryColor !== selectedColor;
      var styleChanged = selectedStyle && lastGalleryStyle !== selectedStyle;
      var shouldUpdateGallery =
        initialSync ||
        packChanged ||
        colorChanged ||
        styleChanged;
      if (!shouldUpdateGallery) return;
      lastGalleryPackKey = getActiveCatalogKey();
      lastGalleryColor = selectedColor;
      lastGalleryStyle = selectedStyle;
      hasInitializedGallery = true;
      gallerySyncTimer && clearTimeout(gallerySyncTimer);
      gallerySyncTimer = setTimeout(function () {
        updateGalleryForActivePack(
          getActiveCatalogKey(),
          selectedOptions,
          initialSync || packChanged || colorChanged || styleChanged
        );
      }, 50);
    }

    var quantityLabelEl = null;
    function ensureQuantityLabel() {
      if (quantityLabelEl && document.body.contains(quantityLabelEl)) return quantityLabelEl;

      // Prefer label rendered by Liquid/snippet/block (initial state).
      var existing = document.querySelector('.wildhawk-pack-quantity');
      if (existing) {
        quantityLabelEl = existing;
        return quantityLabelEl;
      }

      var buyButtonsBlock = getBuyButtonsBlock();
      if (!buyButtonsBlock) return null;

      quantityLabelEl = document.createElement('div');
      quantityLabelEl.className = 'wildhawk-pack-quantity';
      quantityLabelEl.style.marginBottom = '24px';
      // Ensure it takes the full flex row, so pack buttons wrap below.
      quantityLabelEl.style.flex = '0 0 100%';
      quantityLabelEl.style.width = '100%';

      var regular = document.createElement('span');
      regular.textContent = 'Quantity: ';
      regular.style.fontFamily = 'Reposte-Regular';
      regular.style.fontSize = '16px';
      regular.style.color = 'rgb(16, 16, 16)';

      var medium = document.createElement('span');
      medium.className = 'wildhawk-pack-quantity__value';
      medium.textContent = '';
      medium.style.fontFamily = 'Reposte-Medium';
      medium.style.fontSize = '16px';
      medium.style.color = 'rgb(16, 16, 16)';

      quantityLabelEl.appendChild(regular);
      quantityLabelEl.appendChild(medium);

      // Fallback insertion if Liquid label isn't present.
      var buttonStack = buyButtonsBlock.querySelector('.product-form-buttons');
      if (buttonStack && buttonStack.parentNode) buttonStack.parentNode.insertBefore(quantityLabelEl, buttonStack);
      else buyButtonsBlock.insertBefore(quantityLabelEl, buyButtonsBlock.firstChild);
      return quantityLabelEl;
    }

    function packKeyToLabel(packKey) {
      var labels = window.__WILDHAWK_PACK_LABELS__;
      if (labels && typeof labels === 'object' && packKey && labels[packKey]) {
        return String(labels[packKey]);
      }
      if (packKey === 'single') return 'Single Pair';
      if (packKey === 'threePack') return '3-Pack';
      if (packKey === 'fivePack') return '5-Pack';
      if (packKey === 'sevenPack') return '7-Pack';
      if (packKey === 'onePack') return '1 30-Pack';
      return 'Single Pair';
    }

    function updateQuantityLabel() {
      var el = ensureQuantityLabel();
      if (!el) return;
      var valueEl = el.querySelector('.wildhawk-pack-quantity__value');
      if (!valueEl) return;
      valueEl.textContent = packKeyToLabel(activePackKey);
    }

    /**
     * Add-to-cart price display: always "$" before the amount; omit ".00" for whole dollars;
     * show cents when non-zero (e.g. $39.10).
     */
    function variantPriceToUnitCents(raw) {
      if (raw == null || raw === '') return NaN;
      if (typeof raw === 'number' && Number.isFinite(raw)) {
        // Decimal dollars (e.g. 102.5) from some endpoints
        if (Math.abs(raw % 1) > Number.EPSILON) return Math.round(raw * 100);
        return Math.round(raw);
      }
      var digits = parseInt(String(raw).replace(/\D/g, ''), 10);
      return Number.isFinite(digits) ? digits : NaN;
    }

    /**
     * When Ajax price is parsed as cents but was actually whole dollars (e.g. 102 → $1.02),
     * ratio vs bootstrap corrects the Add to cart / headline to the pack sale (e.g. $102).
     */
    function reconcileUnitCentsWithBootstrap(productKey, unitCents) {
      var boot = getBootstrapPriceCentsForKey(productKey);
      if (!isFinite(unitCents) || !isFinite(boot) || boot <= 0 || unitCents <= 0) return unitCents;
      if (boot / unitCents >= 50) return boot;
      return unitCents;
    }

    function formatHoldSpPriceFromCents(cents) {
      if (cents == null || cents === '') return '';
      var n = typeof cents === 'number' ? Math.round(cents) : parseInt(String(cents).replace(/\D/g, ''), 10);
      if (!isFinite(n)) return '';
      var whole = Math.floor(n / 100);
      var frac = n % 100;
      if (frac === 0) return '$' + whole;
      return '$' + whole + '.' + (frac < 10 ? '0' : '') + frac;
    }

    function getLineItemQuantity(buyButtonsBlock) {
      if (!buyButtonsBlock) return 1;
      var inp = buyButtonsBlock.querySelector('input[name="quantity"]');
      if (!inp) return 1;
      var q = parseInt(String(inp.value), 10);
      if (!isFinite(q) || q < 1) q = 1;
      return q;
    }

    var quantityPriceListenersBound = false;
    function ensureQuantityPriceListeners() {
      if (quantityPriceListenersBound) return;
      var buy = getBuyButtonsBlock();
      if (!buy) return;
      var qtyInput = buy.querySelector('input[name="quantity"]');
      if (!qtyInput) return;
      quantityPriceListenersBound = true;

      var refreshPrice = function () {
        var bb = getBuyButtonsBlock();
        if (!bb) return;
        var hid = bb.querySelector('input[type="hidden"][name="id"][ref="variantId"]');
        if (!hid || !hid.value) return;
        scheduleHoldSpPriceUpdate(getActiveCatalogKey(), hid.value);
      };

      qtyInput.addEventListener('input', refreshPrice);
      qtyInput.addEventListener('change', refreshPrice);
      buy.addEventListener(
        'click',
        function (ev) {
          var btn = ev.target && ev.target.closest && ev.target.closest('button[name="plus"], button[name="minus"]');
          if (!btn || !buy.contains(btn)) return;
          window.setTimeout(refreshPrice, 0);
        },
        false
      );
    }

    function normalizePriceLabelForCompare(text) {
      return String(text || '')
        .replace(/\s/g, '')
        .replace(/,/g, '')
        .toLowerCase();
    }

    function queryAddToCartHoldSpPrices(buyButtonsBlock) {
      if (!buyButtonsBlock) return [];
      var fromButton = buyButtonsBlock.querySelectorAll(
        '[ref="addToCartButton"] .hold-sp-price, button[name="add"] .hold-sp-price, add-to-cart-component .hold-sp-price'
      );
      if (fromButton && fromButton.length) return Array.prototype.slice.call(fromButton);
      var fallback = buyButtonsBlock.querySelectorAll('.hold-sp-price');
      return fallback && fallback.length ? Array.prototype.slice.call(fallback) : [];
    }

    function getBootstrapPriceCentsForKey(productKey) {
      if (!Array.isArray(targets) || !productKey) return NaN;
      for (var ti = 0; ti < targets.length; ti++) {
        var entry = targets[ti];
        if (!entry || entry.key !== productKey) continue;
        var raw = entry.price;
        if (raw == null || raw === '') return NaN;
        return variantPriceToUnitCents(raw);
      }
      return NaN;
    }

    function getFirstCatalogVariantForHeadline(product) {
      if (!product || !product.variants || !product.variants.length) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (v && v.available !== false) return v;
      }
      return product.variants[0] || null;
    }

    function resolvePackHeadlineUnitCents(productKey, variantId) {
      var promo = getPromoForKey(productKey);
      if (promo && isFinite(promo.price)) return promo.price;

      var product = catalog && catalog[productKey];
      var variant = null;

      if (product && variantId) {
        variant =
          product.variantById && product.variantById[String(variantId)]
            ? product.variantById[String(variantId)]
            : findVariantById(product, variantId);
        if (variant) {
          var fromSelected = reconcileUnitCentsWithBootstrap(
            productKey,
            variantPriceToUnitCents(variant.price)
          );
          if (isFinite(fromSelected)) return fromSelected;
        }
      }

      var boot = getBootstrapPriceCentsForKey(productKey);
      if (isFinite(boot)) return boot;

      if (product) {
        var headlineVariant = variant || getFirstCatalogVariantForHeadline(product);
        if (headlineVariant) {
          var fromCatalog = reconcileUnitCentsWithBootstrap(
            productKey,
            variantPriceToUnitCents(headlineVariant.price)
          );
          if (isFinite(fromCatalog)) return fromCatalog;
        }
      }

      return NaN;
    }

    function resolvePackHeadlineCompareCents(productKey, unitCents, variant) {
      var promo = getPromoForKey(productKey);
      if (promo && isFinite(promo.compare) && promo.compare > unitCents) {
        return promo.compare;
      }

      if (variant) {
        var cmpCents = variantPriceToUnitCents(variant.compare_at_price);
        if (isFinite(cmpCents) && cmpCents > unitCents) return cmpCents;
      }

      var product = catalog && catalog[productKey];
      if (!variant && product) {
        variant = getFirstCatalogVariantForHeadline(product);
        if (variant) {
          var cmpFromCatalog = variantPriceToUnitCents(variant.compare_at_price);
          if (isFinite(cmpFromCatalog) && cmpFromCatalog > unitCents) return cmpFromCatalog;
        }
      }

      return NaN;
    }

    function resolvePackQty(productKey) {
      var promo = getPromoForKey(productKey);
      if (promo && isFinite(promo.qty) && promo.qty > 0) return promo.qty;
      if (!productKey) return 1;
      if (productKey.indexOf('sevenPack') === 0) return 7;
      if (productKey.indexOf('fivePack') === 0) return 5;
      if (productKey.indexOf('threePack') === 0) return 3;
      return 1;
    }

    function formatBuyboxPerPairLabel(unitCents, qty) {
      if (!isFinite(unitCents) || !isFinite(qty) || qty < 1) return '';
      var perPair = Math.round(unitCents / qty);
      var whole = Math.floor(perPair / 100);
      var frac = Math.abs(perPair % 100);
      return '$' + whole + '.' + (frac < 10 ? '0' : '') + frac + '/pair';
    }

    function isLandingBuyboxPage() {
      var t =
        (document.body && document.body.getAttribute('data-template')) ||
        '';
      return (
        t.indexOf('landing-wildhawk') !== -1 ||
        t.indexOf('landing-freewill') !== -1
      );
    }

    function updateProductPriceBlock(productKey, variantId) {
      var packRoot = document.querySelector('[data-wildhawk-pack-pdp]');
      if (!packRoot) return;

      var product = catalog && catalog[productKey];
      var variant = null;

      if (product && variantId) {
        variant =
          product.variantById && product.variantById[String(variantId)]
            ? product.variantById[String(variantId)]
            : null;
        if (!variant) variant = findVariantById(product, variantId);
      }

      var unitCents = resolvePackHeadlineUnitCents(productKey, variantId);
      if (!isFinite(unitCents)) return;

      var compareCents = resolvePackHeadlineCompareCents(productKey, unitCents, variant);
      var fullPrice = isFinite(compareCents) ? formatHoldSpPriceFromCents(compareCents) : '';

      var formatted = formatHoldSpPriceFromCents(unitCents);
      if (!formatted) return;

      // Landings: main table price only (no strike).
      var landingMainOnly = isLandingBuyboxPage();

      var desiredHtml =
        landingMainOnly || fullPrice === '' || !isFinite(compareCents) || compareCents <= unitCents
          ? formatted
          : formatted + '<span class="price-original">' + fullPrice + '</span>';

      packRoot.querySelectorAll('product-price span.price').forEach(function (el) {
        el.style.removeProperty('display');
        if (el.innerHTML === desiredHtml) return;
        el.innerHTML = desiredHtml;
      });
      // Liquid also renders <s class="compare-at-price">; hide on landings / when strike is in .price-original.
      packRoot.querySelectorAll('product-price s.compare-at-price, product-price .compare-at-price').forEach(function (el) {
        el.setAttribute('hidden', 'true');
        el.style.display = 'none';
      });

      var packQty = resolvePackQty(productKey);
      var perPairLabel = formatBuyboxPerPairLabel(unitCents, packQty);
      packRoot.querySelectorAll('[data-buybox-per-pair]').forEach(function (el) {
        if (!perPairLabel) {
          el.style.display = 'none';
          el.textContent = '';
          return;
        }
        el.style.display = '';
        if (el.textContent !== perPairLabel) el.textContent = perPairLabel;
      });
      if (perPairLabel) {
        packRoot.querySelectorAll('product-price [ref="priceContainer"]').forEach(function (pc) {
          if (pc.querySelector('[data-buybox-per-pair]')) return;
          var el = document.createElement('span');
          el.className = 'buybox-per-pair';
          el.setAttribute('data-buybox-per-pair', '');
          el.textContent = perPairLabel;
          pc.appendChild(el);
        });
      }

      if (packRoot.classList) {
        packRoot.classList.add('wildhawk-pack-prices-ready');
      }
    }

    /**
     * Re-apply after rAF so layout runs after other variant:update handlers (wildhawk skips theme morph on PDP).
     */
    function scheduleHoldSpPriceUpdate(productKey, variantId) {
      updateHoldSpPrice(productKey, variantId);
      updateProductPriceBlock(productKey, variantId);
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(function () {
          updateHoldSpPrice(productKey, variantId);
          updateProductPriceBlock(productKey, variantId);
        });
      }
    }

    function updateHoldSpPrice(productKey, variantId) {
      var buyButtonsBlock = getBuyButtonsBlock();
      if (!buyButtonsBlock) return;

      ensureQuantityPriceListeners();

      var product = catalog && catalog[productKey];
      if (!product) return;

      var variant =
        product.variantById && product.variantById[String(variantId)]
          ? product.variantById[String(variantId)]
          : null;

      if (!variant) {
        variant = findVariantById(product, variantId);
      }

      if (!variant) return;

      var promo = getPromoForKey(productKey);
      var unitCents =
        promo && isFinite(promo.price)
          ? promo.price
          : reconcileUnitCentsWithBootstrap(productKey, variantPriceToUnitCents(variant.price));
      if (!isFinite(unitCents)) return;

      var qty = getLineItemQuantity(buyButtonsBlock);
      var totalCents = Math.round(unitCents * qty);
      var formatted = formatHoldSpPriceFromCents(totalCents);
      if (!formatted) return;

      var priceEls = queryAddToCartHoldSpPrices(buyButtonsBlock);
      if (!priceEls || priceEls.length === 0) return;

      var formattedNorm = normalizePriceLabelForCompare(formatted);
      priceEls.forEach(function (el) {
        el.style.display = 'inline-block';
        if (normalizePriceLabelForCompare(el.textContent) === formattedNorm) return;
        el.textContent = formatted;
      });
    }

    // Create the label immediately on initialization.
    updateQuantityLabel();

    function getFormEl() {
      return (
        document.querySelector('.product-information-new .variant-picker__form') ||
        document.querySelector('.variant-picker__form') ||
        document.querySelector('.product-information-new form.shopify-product-form[data-type="add-to-cart-form"]') ||
        document.querySelector('.product-information-new form[action*="/cart/add"]')
      );
    }

    var lastGalleryPackKey = null;
    var lastGalleryColor = null;
    var lastGalleryStyle = null;
    var gallerySyncTimer = null;
    var hasInitializedGallery = false;

    function isColorOption(name) {
      var lower = String(name || '').toLowerCase();
      return lower === 'color' || lower === 'colour' || lower === 'farbe' || lower === 'couleur';
    }

    function normalizeVariantCoverToken(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    // Alt format (no prefixes):
    // - "All" -> show in all cases
    // - "Style:Briefs/Boxer Briefs/All, Color:Navy Blue/Black/All"
    // We treat "All" as wildcard per-dimension.
    function parseAltSelectionRules(altText) {
      var alt = String(altText || '').trim();
      if (!alt) return { type: 'none', specified: [] };

      if (alt.toLowerCase() === 'all') {
        return { type: 'all' };
      }

      var parts = alt.split(',');
      var rules = {};
      var specified = [];

      function normKey(key) {
        var k = normalizeVariantCoverToken(key);
        if (k === 'colour') return 'color';
        if (k === 'color') return 'color';
        return k;
      }

      parts.forEach(function (part) {
        var p = String(part || '').trim();
        if (!p) return;

        var m = p.match(/^\s*([^:=]+)\s*[:=]\s*(.+?)\s*$/);
        if (!m) return;

        var rawKey = m[1];
        var rawValue = m[2];
        if (!rawKey || !rawValue) return;

        var key = normKey(rawKey);
        if (key !== 'style' && key !== 'color') return;

        var allowedArr = String(rawValue || '')
          .split('/')
          .map(function (s) {
            return normalizeVariantCoverToken(s);
          })
          .filter(function (s) {
            return !!s;
          });

        var wildcard = allowedArr.includes('all');
        rules[key] = { wildcard: wildcard, allowed: new Set(allowedArr) };
        if (!specified.includes(key)) specified.push(key);
      });

      return { type: 'rules', rules: rules, specified: specified };
    }

    function getSelectedOptionValue(selectedOptions, key) {
      if (!selectedOptions || !selectedOptions.byName) return null;

      if (key === 'color') {
        var colorVal = null;
        Object.keys(selectedOptions.byName).some(function (optName) {
          var optNorm = normalizeVariantCoverToken(optName);
          if (optNorm === 'color' || optNorm === 'colour') {
            colorVal = selectedOptions.byName[optName];
            return true;
          }
          return false;
        });
        return colorVal;
      }

      var want = normalizeVariantCoverToken(key);
      var val = null;
      Object.keys(selectedOptions.byName).some(function (optName) {
        var optNorm = normalizeVariantCoverToken(optName);
        if (optNorm === want) {
          val = selectedOptions.byName[optName];
          return true;
        }
        return false;
      });
      return val;
    }

    function getAltMatch(altText, selectedOptions) {
      var parsed = parseAltSelectionRules(altText);

      if (parsed.type === 'all') return { match: true, score: 999 };
      if (parsed.type === 'none' || !parsed.specified || parsed.specified.length === 0) {
        // Keep visible if alt doesn't declare Style/Color rules.
        return { match: true, score: 0 };
      }

      var selectedStyle = getSelectedOptionValue(selectedOptions, 'style');
      var selectedColor = getSelectedOptionValue(selectedOptions, 'color');

      var score = 0;
      for (var i = 0; i < parsed.specified.length; i++) {
        var k = parsed.specified[i];
        var rule = parsed.rules[k];
        if (!rule) continue;
        if (rule.wildcard) continue;

        var selectedVal = k === 'style' ? selectedStyle : selectedColor;
        if (!selectedVal) return { match: false, score: 0 };

        var selectedNorm = normalizeVariantCoverToken(selectedVal);
        if (!rule.allowed.has(selectedNorm)) return { match: false, score: 0 };

        score += 5;
      }

      return { match: true, score: score };
    }

    function extractVariantCoverTags(altText) {
      if (!altText) return [];
      var parts = [];
      // Capture everything after `variant-cover:` up to the next `|`, then split further.
      var regex = /variant-cover\s*:\s*([^|]+)/gi;
      var match;
      while ((match = regex.exec(altText)) !== null) {
        var blob = String(match[1] || '');
        // Support comma/semicolon separated tokens inside the same variant-cover blob.
        blob
          .split(/[;,]+/)
          .map(function (s) {
            return String(s || '').trim();
          })
          .filter(function (s) {
            return !!s;
          })
          .forEach(function (s) {
            parts.push(s);
          });
      }
      return parts;
    }

    function extractThumbColorTags(altText) {
      if (!altText) return [];
      var parts = [];
      var regex = /thumb-color\s*:\s*([^|]+)/gi;
      var match;
      while ((match = regex.exec(altText)) !== null) {
        var blob = String(match[1] || '');
        blob
          .split(/[;,]+/)
          .map(function (s) {
            return String(s || '').trim();
          })
          .filter(function (s) {
            return !!s;
          })
          .forEach(function (s) {
            parts.push(s);
          });
      }
      return parts;
    }

    function getVariantCoverMatchScore(altText, selectedOptions) {
      var tokens = extractVariantCoverTags(altText);
      if (!tokens.length) return 0;

      var normalizedSelected = {};
      if (selectedOptions && selectedOptions.byName) {
        Object.keys(selectedOptions.byName).forEach(function (optName) {
          normalizedSelected[normalizeVariantCoverToken(optName)] = normalizeVariantCoverToken(selectedOptions.byName[optName]);
        });
      }

      // Restrictions are AND rules over keys we find: e.g. Style in {Briefs,All} AND Color in {Black}
      var wildcardAll = false;
      var restrictions = {};

      function splitAllowedValues(valueStr) {
        // Accept "Briefs/Boxer Briefs/All" style.
        var normalized = String(valueStr || '').replace(/\s+or\s+/gi, '/');
        return normalized
          .split(/[\/|]+/)
          .map(function (s) {
            return normalizeVariantCoverToken(s);
          })
          .filter(function (s) {
            return !!s;
          });
      }

      tokens.forEach(function (rawToken) {
        var token = String(rawToken || '').trim();
        if (!token) return;

        var normToken = normalizeVariantCoverToken(token);
        if (normToken === 'all') {
          wildcardAll = true;
          return;
        }

        // Support `Key=Value` or `Key:Value`
        var m = token.match(/^\s*([^:=]+)\s*[:=]\s*(.+)\s*$/);
        if (m) {
          var key = m[1];
          var valueStr = m[2];
          var keyNorm = normalizeVariantCoverToken(key);

          var allowed = splitAllowedValues(valueStr);
          if (!allowed.length) return;

          if (allowed.includes('all')) {
            // Wildcard for this dimension: no restriction needed.
            return;
          }

          restrictions[keyNorm] = new Set(allowed);
          return;
        }

        // Value-only token: restrict whichever option(s) currently equal this value.
        var matchingKeys = Object.keys(normalizedSelected).filter(function (k) {
          return normalizedSelected[k] === normToken;
        });

        if (!matchingKeys.length) return;

        matchingKeys.forEach(function (keyNorm) {
          restrictions[keyNorm] = new Set([normToken]);
        });
      });

      if (wildcardAll) return 999;

      var restrictionKeys = Object.keys(restrictions);
      if (!restrictionKeys.length) return 1; // tokens existed but no key-specific restrictions

      var score = 0;
      for (var i = 0; i < restrictionKeys.length; i++) {
        var k = restrictionKeys[i];
        var selectedVal = normalizedSelected[k];
        if (!selectedVal) return 0;
        var allowedSet = restrictions[k];
        if (allowedSet && allowedSet.has(selectedVal)) {
          score += 5;
        } else {
          return 0;
        }
      }

      return score;
    }

    function getThumbColorTagState(altText, selectedColor) {
      var tokens = extractThumbColorTags(altText);
      if (!tokens.length) return { hasTag: false, matches: true };
      if (!selectedColor) return { hasTag: true, matches: true };

      // If the thumb-color token includes `All`, it should be shown in all cases.
      for (var i = 0; i < tokens.length; i++) {
        var norm = normalizeVariantCoverToken(tokens[i]);
        if (norm === 'all') return { hasTag: true, matches: true };
      }

      var selectedToken = normalizeVariantCoverToken(selectedColor);
      var matches = false;

      tokens.forEach(function (tagValue) {
        var token = normalizeVariantCoverToken(tagValue);
        if (!token) return;
        if (token === selectedToken) matches = true;
      });

      return { hasTag: true, matches: matches };
    }

    function getSelectedColorFromSelectedOptions(selectedOptions) {
      if (!selectedOptions || !selectedOptions.byName) return { selectedColor: null, colorOptionName: null };

      var selectedColor = null;
      var colorOptionName = null;
      Object.keys(selectedOptions.byName).some(function (optName) {
        if (isColorOption(optName) && selectedOptions.byName[optName]) {
          selectedColor = selectedOptions.byName[optName];
          colorOptionName = optName;
          return true;
        }
        return false;
      });

      return { selectedColor: selectedColor, colorOptionName: colorOptionName };
    }

    function findVariantById(product, variantId) {
      if (!product || !Array.isArray(product.variants)) return null;
      var idNum = parseInt(variantId, 10);
      if (isNaN(idNum)) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (Number(product.variants[i].id) === Number(idNum)) return product.variants[i];
      }
      return null;
    }

    function getVariantCoverMedia(product, selectedOptions) {
      // Pick the highest scoring media by variant-cover tags.
      var best = null;
      var bestScore = 0;
      if (!product || !Array.isArray(product.media)) return null;

      for (var i = 0; i < product.media.length; i++) {
        var item = product.media[i];
        var score = getVariantCoverMatchScore(item.alt, selectedOptions);
        if (score > bestScore) {
          bestScore = score;
          best = item;
        }
      }
      return best;
    }

    function updateGalleryForActivePack(packKey, selectedOptions, forceFirstSlide) {
      var product = window.wildhawkPackCatalog && window.wildhawkPackCatalog[packKey];
      if (!product || !Array.isArray(product.media)) return;

      var mainSlider = document.querySelector('#product-main-slider');
      var thumbSlider = document.querySelector('#product-thumb-slider');
      if (!mainSlider || !thumbSlider) return;

      var mainList = mainSlider.querySelector('.splide__list');
      var thumbList = thumbSlider.querySelector('.splide__list');
      if (!mainList || !thumbList) return;

      // Preserve current carousel index instead of always jumping to the first slide.
      var prevMainIndex =
        window.mainSplide && typeof window.mainSplide.index === 'number'
          ? window.mainSplide.index
          : 0;

      var filteredMedia = product.media.filter(function (item) {
        var altValue = String(item.alt || '').toLowerCase();

        // Keep core/empty alts visible.
        if (!item.alt || altValue.includes('main-product-image')) return true;

        var match = getAltMatch(item.alt, selectedOptions);
        return match.match;
      });

      var mainSlidesHtml = filteredMedia
        .map(function (item) {
          if (item.media_type === 'image') {
            return (
              '<li class="splide__slide"><img src="' +
              item.src +
              '" alt="' +
              (item.alt || '') +
              '" loading="lazy"></li>'
            );
          }
          if (item.media_type === 'video') {
            var src = item.sources && item.sources.length > 0 && item.sources[0].url ? item.sources[0].url : '';
            var poster = item.thumb || '';
            return (
              '<li class="splide__slide video-slide"><div class="video-wrapper"><video src="' +
              src +
              '" class="product-gallery-video" playsinline muted loop autoplay poster="' +
              poster +
              '"></video></div></li>'
            );
          }

          // Fallback: render as image if we have src.
          if (item.src) {
            return (
              '<li class="splide__slide"><img src="' +
              item.src +
              '" alt="' +
              (item.alt || '') +
              '" loading="lazy"></li>'
            );
          }
          return '';
        })
        .join('');

      var thumbSlidesHtml = filteredMedia
        .map(function (item) {
          if (item.media_type === 'video') {
            var poster = item.thumb || item.src || '';
            return (
              '<li class="splide__slide"><img src="' +
              poster +
              '" alt="' +
              (item.alt || '') +
              '" loading="lazy"><span class="video-thumb-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M8 5v14l11-7z"/></svg></span></li>'
            );
          }
          return (
            '<li class="splide__slide"><img src="' +
            (item.thumb || item.src) +
            '" alt="' +
            (item.alt || '') +
            '" loading="lazy"></li>'
          );
        })
        .join('');

      mainList.innerHTML = mainSlidesHtml;
      thumbList.innerHTML = thumbSlidesHtml;

      // Re-mount Splide so swapped slide DOM is fully recognized (style-split packs have different media sets).
      if (typeof window.initializeSplide === 'function') {
        window.initializeSplide();
      } else {
        // Fallback: refresh existing instances if re-init isn't available.
        if (window.mainSplide && typeof window.mainSplide.refresh === 'function') window.mainSplide.refresh();
        if (window.mainThumbs && typeof window.mainThumbs.refresh === 'function') window.mainThumbs.refresh();
      }

      // After mount/refresh, position sliders.
      if (window.mainSplide && typeof window.mainSplide.go === 'function') {
        var newCount = mainList.querySelectorAll('.splide__slide').length || 0;
        var targetIndex = 0;
        if (!forceFirstSlide) {
          targetIndex = newCount > 0 ? Math.min(prevMainIndex, newCount - 1) : 0;
        }
        window.mainSplide.go(targetIndex);
      }
      if (window.mainThumbs && typeof window.mainThumbs.go === 'function') {
        window.mainThumbs.go(0);
      }
    }

    /**
     * Freewill PDP: Briefs are only sold in Black — hide Navy/Navy Blue swatches (same as landing).
     */
    function syncFreewillBriefColorRestrictions(formEl) {
      if (!formEl) return;
      if (document.body.getAttribute('data-template') !== 'product.freewill'
          && document.body.getAttribute('data-template') !== 'product.freewill-no-promo') return;
      if (!document.querySelector('input[data-wildhawk-pack-style]')) return;

      var colorFs = formEl.querySelector('fieldset.type-Color');
      if (!colorFs) return;

      var checkedStyle = document.querySelector('input[data-wildhawk-pack-style]:checked');
      var styleKey = checkedStyle ? normalizeStyleKey(checkedStyle.value) : null;
      var hideNavy = styleKey === 'brief';

      function isRestrictedNavyColor(val) {
        var n = normalizeVariantCoverToken(val);
        return n === 'navy blue' || n === 'navy';
      }

      var navyRadio = null;
      colorFs.querySelectorAll('label.variant-option__button-label').forEach(function (label) {
        var inp = label.querySelector('input[type="radio"]');
        if (!inp) return;
        if (isRestrictedNavyColor(inp.value)) {
          navyRadio = inp;
          label.style.display = hideNavy ? 'none' : '';
        } else {
          label.style.display = '';
        }
      });

      if (hideNavy && navyRadio && navyRadio.checked) {
        var fallback = null;
        colorFs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
          if (inp === navyRadio || isRestrictedNavyColor(inp.value)) return;
          var lbl = inp.closest('label');
          if (!lbl || lbl.style.display === 'none') return;
          fallback = inp;
        });
        if (!fallback) {
          colorFs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
            if (inp !== navyRadio && !isRestrictedNavyColor(inp.value)) {
              fallback = inp;
            }
          });
        }
        if (fallback) {
          navyRadio.checked = false;
          fallback.checked = true;
          fallback.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    function sync(formElOverride) {
      var formEl =
        formElOverride !== undefined && formElOverride !== null ? formElOverride : getFormEl();

      syncFreewillBriefColorRestrictions(formEl);

      updateQuantityLabel();
      syncStitchProductTitle();

      var selectedOptions = withPackStyleSelection(
        formEl ? getSelectedOptionValueMaps(formEl) : { byPosition: {}, byName: {} }
      );

      var activeCatalogKeyEarly = getActiveCatalogKey();

      // No Size yet (underwear only): keep "Select a size" visible; only sync gallery + headline price.
      if (formEl && wildhawkPackRequiresSize(formEl) && !wildhawkSizeSelected(formEl)) {
        hideWildhawkPackAtcUi();
        setWildhawkAddToCartDisabled(true);
        clearHiddenVariantIds();
        syncGalleryIfNeeded(selectedOptions);
        updateProductPriceBlock(activeCatalogKeyEarly, null);
        if (typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(function () {
            updateProductPriceBlock(activeCatalogKeyEarly, null);
          });
        }
        if (window.WildhawkStockout && typeof window.WildhawkStockout.applyToPdpPicker === 'function') {
          window.WildhawkStockout.applyToPdpPicker(document);
        }
        if (window.WhLowStock) window.WhLowStock.hide(getPackPdpRoot());
        return;
      }

      showWildhawkPackAtcUi();

      var activeCatalogKey = activeCatalogKeyEarly;
      var variantId = findVariantIdForPack(activeCatalogKey, selectedOptions);
      if (!variantId) {
        if (activePackKey === 'single') console.warn('[Wildhawk pack] No variant match for single', selectedOptions);
        if (activePackKey === 'onePack') console.warn('[Wildhawk pack] No variant match for onePack', selectedOptions);
        if (activePackKey === 'fivePack') console.warn('[Wildhawk pack] No variant match for fivePack', selectedOptions);
        if (activePackKey === 'sevenPack') console.warn('[Wildhawk pack] No variant match for sevenPack', selectedOptions);
        clearHiddenVariantIds();
        setWildhawkAddToCartDisabled(true);
        syncGalleryIfNeeded(selectedOptions);
        updateProductPriceBlock(activeCatalogKey, null);
        if (typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(function () {
            updateProductPriceBlock(activeCatalogKey, null);
          });
        }
        if (window.WildhawkStockout && typeof window.WildhawkStockout.applyToPdpPicker === 'function') {
          window.WildhawkStockout.applyToPdpPicker(document);
        }
        if (window.WhLowStock) window.WhLowStock.hide(getPackPdpRoot());
        return;
      }

      var packProduct = catalog[activeCatalogKey];
      var resolvedVariant =
        packProduct && packProduct.variantById && packProduct.variantById[String(variantId)]
          ? packProduct.variantById[String(variantId)]
          : findVariantById(packProduct, variantId);

      if (!resolvedVariant || resolvedVariant.available === false) {
        setWildhawkAddToCartDisabled(true);
      } else {
        setWildhawkAddToCartDisabled(false);
      }

      setHiddenVariantId(variantId);

      scheduleHoldSpPriceUpdate(activeCatalogKey, variantId);
      updateQuantityLabel();
      syncGalleryIfNeeded(selectedOptions);

      if (window.WhLowStock) {
        // Size is already required above; selectedOptions is { byName, byPosition }.
        window.WhLowStock.update(getPackPdpRoot(), resolvedVariant);
      }

      // Size buttons are rendered for the page product; Style switches catalog products
      // without remounting Size — refresh OOS from the active pack entry.
      if (window.WildhawkStockout && typeof window.WildhawkStockout.applyToPdpPicker === 'function') {
        window.WildhawkStockout.applyToPdpPicker(document);
      }
    }

    // Pack switcher clicks: prevent navigation, switch active pack, sync variant id.
    switcher.addEventListener('click', function (event) {
      var target = event.target;
      var btn = target && target.closest ? target.closest('.pack-btn[data-pack-key]') : null;
      if (!btn) return;

      event.preventDefault();

      var newKey = btn.dataset.packKey;
      if (!newKey) return;

      activePackKey = newKey;

      // Toggle active styles.
      switcher.querySelectorAll('.pack-btn[data-pack-key]').forEach(function (b) {
        if (b === btn) b.classList.add('active');
        else b.classList.remove('active');
      });

      clearHiddenVariantIds();
      setWildhawkAddToCartDisabled(true);
      sync();
    });

    document.addEventListener('change', function (event) {
      var t = event && event.target ? event.target : null;
      if (!t || !t.matches || !t.matches('input[data-wildhawk-pack-style]')) return;
      var newStyle = normalizeStyleKey(t.value);
      if (!newStyle) return;
      activeStyleKey = newStyle;
      syncStyleLegendAndSelectedClasses();
      clearHiddenVariantIds();
      setWildhawkAddToCartDisabled(true);
      sync();
    });

    // Any variant option change: recompute variant id for the current active pack.
    document.addEventListener('variant:update', function (event) {
      // Theme updates the hidden variant input on this event.
      // Re-apply our pack-specific mapping on the next tick so it wins.
      var pickerTarget = event && event.target ? event.target : null;
      function runAfterVariantSection() {
        var picker = pickerTarget;
        var maybeForm = picker && picker.querySelector ? picker.querySelector('.variant-picker__form') : null;
        var form = maybeForm || getFormEl();
        if (form && !wildhawkSizeSelected(form)) {
          var selectedOptions = withPackStyleSelection(getSelectedOptionValueMaps(form));
          syncGalleryIfNeeded(selectedOptions);
          ensureAtcDisabledIfNoSizeSelected();
          var akNoSize = getActiveCatalogKey();
          updateProductPriceBlock(akNoSize, null);
          if (typeof window.requestAnimationFrame === 'function') {
            window.requestAnimationFrame(function () {
              updateProductPriceBlock(akNoSize, null);
            });
          }
          return;
        }
        sync(maybeForm || null);
      }
      window.setTimeout(runAfterVariantSection, 0);
      // Section fetch + morph finish slightly later; second pass keeps hold-sp-price on Add to cart at $102 (sale).
      window.setTimeout(runAfterVariantSection, 90);
    });

    document.addEventListener('change', function (e) {
      var form = getFormEl();
      if (!form || !(e.target instanceof Node) || !form.contains(e.target)) return;
      sync(form);
    });

    // Defer so variant-picker pack PDP microtask can clear default Size before we read the form.
    window.setTimeout(function () {
      var f = getFormEl();
      if (f && wildhawkPackRequiresSize(f) && !wildhawkSizeSelected(f)) {
        setWildhawkAddToCartDisabled(true);
        clearHiddenVariantIds();
      }
      sync();
    }, 0);
  }
})();
